// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PX8D","colBig":"styles_colBig__2eU4m","colSmall":"styles_colSmall__1-weC","shopifyNameWrapper":"styles_shopifyNameWrapper__PObGw"};